import state from './modulePersonState.js'
import mutations from './modulePersonMutations.js'
import actions from './modulePersonActions.js'
import getters from './modulePersonGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
